import React from 'react';
import { PropTypes } from 'prop-types';
import { Grid } from '@mui/material';
import { isNil } from 'lodash';
import { SessionStatusIcon } from '../IndicatorIcon/SessionStatusIcon';

export const ActionCardHeader = ({ status, headerText, rightComponent }) => {
  const showActionNeeded = !isNil(rightComponent);
  return (
    <Grid container direction="row">
      <Grid item xs={2}>
        <SessionStatusIcon status={status} />
      </Grid>
      <Grid item xs={8}>
        <span style={{ fontWeight: 600 }}>{headerText}</span>
      </Grid>
      <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'end' }}>
        {showActionNeeded && rightComponent}
      </Grid>
    </Grid>
  );
};

ActionCardHeader.propTypes = {
  status: PropTypes.string.isRequired,
  headerText: PropTypes.string.isRequired,
  rightComponent: PropTypes.node,
};
